module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00176.8a835623.jpg";